import { render, staticRenderFns } from "./participant-login-disclaimer.vue?vue&type=template&id=5944731a&scoped=true&"
import script from "./participant-login-disclaimer.vue?vue&type=script&lang=js&"
export * from "./participant-login-disclaimer.vue?vue&type=script&lang=js&"
import style0 from "./participant-login-disclaimer.vue?vue&type=style&index=0&id=5944731a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5944731a",
  null
  
)

component.options.__file = "participant-login-disclaimer.vue"
export default component.exports